let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cj5mx")).then(() => parcelRequire('kxkv9'));